// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.anagram-wrapper {
  text-align: center;
  padding: 20px;
  font-family: Arial;
}

.top-bar {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}

.scrambled {
  font-size: 32px;
  letter-spacing: 6px;
  margin: 20px 0;
  font-weight: bold;
}

.input-row {
  margin: 10px 0;
}

input {
  padding: 8px;
  font-size: 16px;
  margin-right: 10px;
}

button {
  padding: 8px 12px;
  margin: 5px;
  cursor: pointer;
}

.btn-row {
  margin-top: 10px;
}

.result {
  margin: 10px;
  font-weight: bold;
}

.answers {
  margin-top: 15px;
}

.answers span {
  display: inline-block;
  margin: 5px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.hidden {
  background: #444;
  color: transparent;
}

.found {
  background: #4ade80;
  color: black;
}

.next-btn {
  background: #60a5fa;
  border: none;
  border-radius: 6px;
  font-weight: bold;
}

.next-btn:disabled {
  background: #555;
  cursor: not-allowed;
}

.reset-btn {
  background: #f87171;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: bold;
}

.reset-btn:hover {
  background: #ef4444;
}

.score {
  margin-top: 15px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/features/Games/Anagram/anagram.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".anagram-wrapper {\n  text-align: center;\n  padding: 20px;\n  font-family: Arial;\n}\n\n.top-bar {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.scrambled {\n  font-size: 32px;\n  letter-spacing: 6px;\n  margin: 20px 0;\n  font-weight: bold;\n}\n\n.input-row {\n  margin: 10px 0;\n}\n\ninput {\n  padding: 8px;\n  font-size: 16px;\n  margin-right: 10px;\n}\n\nbutton {\n  padding: 8px 12px;\n  margin: 5px;\n  cursor: pointer;\n}\n\n.btn-row {\n  margin-top: 10px;\n}\n\n.result {\n  margin: 10px;\n  font-weight: bold;\n}\n\n.answers {\n  margin-top: 15px;\n}\n\n.answers span {\n  display: inline-block;\n  margin: 5px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.hidden {\n  background: #444;\n  color: transparent;\n}\n\n.found {\n  background: #4ade80;\n  color: black;\n}\n\n.next-btn {\n  background: #60a5fa;\n  border: none;\n  border-radius: 6px;\n  font-weight: bold;\n}\n\n.next-btn:disabled {\n  background: #555;\n  cursor: not-allowed;\n}\n\n.reset-btn {\n  background: #f87171;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: bold;\n}\n\n.reset-btn:hover {\n  background: #ef4444;\n}\n\n.score {\n  margin-top: 15px;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
